const o = "_wrapper_bnoox_1", n = "_contentWrapper_bnoox_16", e = "_contactSection_bnoox_25", t = "_image_bnoox_30", c = "_link_bnoox_43", _ = "_name_bnoox_47", a = "_jobTitle_bnoox_50", r = "_geographicAreas_bnoox_51", p = {
  wrapper: o,
  contentWrapper: n,
  contactSection: e,
  image: t,
  link: c,
  name: _,
  jobTitle: a,
  geographicAreas: r
};
export {
  e as contactSection,
  n as contentWrapper,
  p as default,
  r as geographicAreas,
  t as image,
  a as jobTitle,
  c as link,
  _ as name,
  o as wrapper
};
